export default __webpack_public_path__ + "static/media/altay.6eace93c.jpg";